import React from "react";
import ReactDOM from "react-dom";
import { Spinner, Row, Col, Progress } from "reactstrap";
import axios from "axios";
import "../App.css";
import { Layout } from "./layout/layout";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {}

  render() {
    const { error } = this.state;
    const { children } = this.props;
    if (this.state.hasError) {
      return (
        <div>
          <Col style={{ position: "relative", top: "25vh" }}>
            <Row className="d-flex justify-content-center">
              <h1>An error has occured</h1>
            </Row>
          </Col>
        </div>
      );
    }

    return children;
  }
}
export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/views/error.jsx